import { render, staticRenderFns } from "./OrderPlateDetail.vue?vue&type=template&id=83595a28&scoped=true&"
import script from "./OrderPlateDetail.vue?vue&type=script&lang=js&"
export * from "./OrderPlateDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderPlateDetail.vue?vue&type=style&index=0&id=83595a28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83595a28",
  null
  
)

export default component.exports